import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BlockComponent } from '../block/block.component';

@Component({
  selector: 'app-blocks-grid',
  templateUrl: './blocks-grid.component.html',
  styleUrls: ['./blocks-grid.component.scss'],
  standalone: true,
  imports: [NgStyle, BlockComponent],
})
export class BlocksGridComponent {
  @Input() countToShow = 4;
  @Input() blockRows = 2;
  @Input() blockIdentifiers: string[] = [];

  /**
   * Returns a string that represents the CSS grid template rows property for a grid layout.
   * @returns {string} The CSS grid template rows property in the format `repeat(n, 1fr)`, where `n` is the number of rows in the grid layout.
   */
  get blockRowsStyle(): string {
    return `repeat(${this.blockRows}, 1fr)`;
  }
}
